<template>
<div class="chapter">
<div class="inner_page">
<section class="" data-pdf-bookmark="Acknowledgments" data-type="preface" epub:type="preface"><div class="preface" id="d1e248"><h1 class="FMHeadfmh"><span href="#/toc01" title="Link target outside of Sample">Acknowledgments</span></h1>
<p class="FMTextNo-Indentfmtx1">This book wouldn’t exist without Diana, my editor. I’d also like to thank Erich, for basically feeding me while I wrote this book; Pip, for a receptive ear; Amar, for feedback on transmasculine representation; Eleni for help with the Greek; Heather for letting me steal her name; Marybeth for encouragement and help with outlining; Firestorm Books &amp; Coffee for being my office; and the queers and the punks and the anarchists of Asheville for being such an amazing community. I'd like to thank some of my patrons: Chris Costello, Sam Mikesell, and Hoss, the dog. I’d like to thank everyone who has put their body and their freedom on the line in this era of growing oppression. Finally, I’d like to thank everyone I’ve ever committed a crime with: without you I wouldn’t be the writer I am today.</p></div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface03.vue?656fe4ec